import { SearchTerm } from './SearchTerm';

const IdentityProviderGroupSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "idpGroupName",
        searchOnName: "idpGroupName",
        translationKey: "name"
    }
];

export default IdentityProviderGroupSearch;
